// Retorno seguro al consentimiento OAuth (@Olimpo) tras el login/onboarding obligatorio.
// Solo se guarda/consume una ruta INTERNA cuyo pathname sea EXACTAMENTE /oauth/authorize.
// La query (incluye redirect_uri con https:// legítimo del cliente) se preserva tal cual;
// validamos únicamente el pathname, nunca el contenido de la query.
const KEY = "post_login_redirect";

export function isValidOAuthReturn(path) {
  if (typeof path !== "string" || path.length === 0) return false;
  if (!path.startsWith("/")) return false;          // debe ser relativo a la raíz (mismo origen)
  if (path.startsWith("//")) return false;          // //host → protocol-relative externo
  if (path.includes("\\")) return false;            // barras invertidas
  const q = path.indexOf("?");
  const pathname = q === -1 ? path : path.slice(0, q);
  return pathname === "/oauth/authorize";           // EXACTO: rechaza /oauth/authorize-evil, /oauth/authorizeX
}

export function saveOAuthRedirect(loc) {
  try {
    const path = (loc.pathname || "") + (loc.search || "");
    if (isValidOAuthReturn(path)) sessionStorage.setItem(KEY, path);
  } catch { /* noop */ }
}

// Devuelve la ruta válida (o null) y SIEMPRE limpia la clave (consumo único, sin bucles).
export function consumeOAuthRedirect() {
  let v = null;
  try { v = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); } catch { /* noop */ }
  return isValidOAuthReturn(v) ? v : null;
}

export function clearOAuthRedirect() {
  try { sessionStorage.removeItem(KEY); } catch { /* noop */ }
}
